import { render, staticRenderFns } from "./PageConfig.vue?vue&type=template&id=3a251536&scoped=true"
import script from "./PageConfig.vue?vue&type=script&lang=js"
export * from "./PageConfig.vue?vue&type=script&lang=js"
import style0 from "./PageConfig.vue?vue&type=style&index=0&id=3a251536&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a251536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a251536')) {
      api.createRecord('3a251536', component.options)
    } else {
      api.reload('3a251536', component.options)
    }
    module.hot.accept("./PageConfig.vue?vue&type=template&id=3a251536&scoped=true", function () {
      api.rerender('3a251536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/decorationPage/setPage/PageConfig.vue"
export default component.exports